import React, { ReactElement } from 'react'
import newTruck from './assets/new-truck.svg'
import fitnessTruck from './assets/fitness-truck.svg'
import { DeliveryOptions as EnumDeliveryOptions, DeliveryOption } from './types/DeliveryOptions'
import { HubboxCollectPoint as HubboxCollectPointType } from './types/models'
import HubboxCollectPoint from './HubboxCollectPoint'

type DeliveryOptionsProps = {
  collectionAvailable: boolean;
  deliveryOption: DeliveryOption;
  deliveryPostcodeLabel: string;
  deliveryPostcode: string;
  onDeliveryOptionChanged: (deliveryOption: DeliveryOption) => void
  onDeliveryPostcodeChanged: (postcode: string) => void
  postcodeRequired: () => boolean
  launchHubbox: () => void
  hubboxCollectPoint: HubboxCollectPointType | null
  suitableForLocalCollection: boolean
}

const DeliveryOptions = ({
  collectionAvailable, deliveryOption, deliveryPostcodeLabel, deliveryPostcode,
  onDeliveryOptionChanged, onDeliveryPostcodeChanged,
  postcodeRequired, launchHubbox, hubboxCollectPoint, suitableForLocalCollection
}: DeliveryOptionsProps): ReactElement => (
  <div className="basket-delivery-options">
    <h2 className="heading-with-image">
      <img src={newTruck} alt="" className="only only-tms-inline" loading="lazy" width="20" height="16" />
      <img src={fitnessTruck} alt="" className="only only-fitness-inline" loading="lazy" width="20" height="16" />
      Calculate Delivery
    </h2>
    {postcodeRequired() &&
      <div className="basket-warning">
        Please enter a postcode.
      </div>
    }
    <label className="delivery-area-selection deliver-to-postcode">
      <div className="deliver-to-postcode-radio">
        <input
          type="radio"
          name="delivery_option"
          onChange={(): void => (
            onDeliveryOptionChanged(EnumDeliveryOptions.DeliverToPostcode as DeliveryOption))
          }
          value={EnumDeliveryOptions.DeliverToPostcode}
          data-new-delivery
          checked={deliveryOption === EnumDeliveryOptions.DeliverToPostcode}
          className="delivery-area-selection-radio"
        />
        {deliveryPostcodeLabel}
      </div>
      <div className="deliver-to-postcode-postcode-inputs">
        {deliveryOption === EnumDeliveryOptions.DeliverToPostcode &&
          <input data-recording-ignore="mask" type="text" name="delivery_postcode" value={deliveryPostcode} onChange={(e): void => onDeliveryPostcodeChanged(e.target.value)} className="delivery-postcode-input"/>
        }
      </div>
    </label>
    {collectionAvailable &&
      <label className="delivery-area-selection collecting">
        <input
          type="radio"
          name="delivery_option"
          value={EnumDeliveryOptions.Collection}
          onChange={(): void => (
            onDeliveryOptionChanged(EnumDeliveryOptions.Collection as DeliveryOption))
          }
          data-new-delivery
          checked={deliveryOption === EnumDeliveryOptions.Collection}
          className="delivery-area-selection-radio"
        />
        I am collecting
      </label>
    }
    {suitableForLocalCollection &&
    <label onClick={launchHubbox} className="delivery-area-selection deliver-to-postcode">
        <div className="deliver-to-postcode-radio">
          <input
            type="radio"
            name="delivery_option"
            onChange={(): void => (onDeliveryOptionChanged(EnumDeliveryOptions.LocalCollection as DeliveryOption))}
            value={EnumDeliveryOptions.LocalCollection}
            data-new-delivery
            checked={deliveryOption === EnumDeliveryOptions.LocalCollection}
            className="delivery-area-selection-radio"
          />
          Local pickup
        </div>
      </label>
    }
    {deliveryOption === EnumDeliveryOptions.LocalCollection && (
      hubboxCollectPoint === null
        ? (
            <div className="basket-warning">
              Please select a pickup point.
            </div>
          )
        : (
          <HubboxCollectPoint launchHubbox={launchHubbox} hubboxCollectPoint={hubboxCollectPoint} />
          )
    )}
  </div>
)

export default DeliveryOptions
